// extracted by mini-css-extract-plugin
module.exports = {"content":"QualificationsSection_content__1-60y"};